module.exports = __webpack_public_path__ + "static/media/logotipoVantaz.3a1c205d.svg";